import { render, staticRenderFns } from "./ForumArea.vue?vue&type=template&id=616a1777&scoped=true&"
import script from "./ForumArea.vue?vue&type=script&lang=js&"
export * from "./ForumArea.vue?vue&type=script&lang=js&"
import style0 from "./ForumArea.vue?vue&type=style&index=0&id=616a1777&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a1777",
  null
  
)

export default component.exports